import { render, staticRenderFns } from "./MoldFile.vue?vue&type=template&id=02b2fad7&"
import script from "./MoldFile.vue?vue&type=script&lang=js&"
export * from "./MoldFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports